// extracted by mini-css-extract-plugin
export var linkText = "_qn-0";